// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './api'
import '../theme/index.css'
import ElementUI from 'element-ui'
import pagination from "./components/common/pagination";
import loginConfirm from './components/common/loginConfirm'
// import router from './utils/is_mobile'

window.vm = new Vue()
Vue.prototype.$axios = axios
//设置一个全局用户信息
Vue.prototype.$userInfo = {
  userInfo: {},
  token: localStorage.getItem('token'),
  isLogin: !!localStorage.getItem('token'),
  loginTip: !!localStorage.getItem('loginTip'),
  setToken(token) {
    this.token = token
  },
  setUserInfo(userInfo) {
    this.userInfo = userInfo
  },
  setLoingStatus(status) {
    this.isLogin = status
  }
}
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('pagination', pagination);
Vue.component('loginConfirm', loginConfirm);
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('token')) {
    localStorage.removeItem('token')
    next('/login')
  } else {
    next()
  }
}
);

router.afterEach((to, from, next) => {
  window, scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js